import { useHttpClient } from "@/common/api/httpClient";
import { storeToRefs } from "pinia";
import { useLanguageStore } from "shared/translations/stores/languageStore";
import type { CoilResponse } from "./common/coilResponse";

export interface ListCoilPage {
  coils: CoilResponse[];
}

export interface ListCoilResponse {
  ok: true,
  page: ListCoilPage;
}

export function useListCoils() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  async function execute() {
    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl('coil'), {
      method: 'GET',
      headers,
    });

    const text = translations.value.coils.actions.fetchMany;

    const response = await httpClient.action<ListCoilResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const json = await response.json() as ListCoilPage;

        return {
          ok: true,
          page: json
        };
      },
    });

    return response;
  }

  return {
    execute
  };
}
